import { q } from 'bobjoll/ts/library/dom';

import triggerManualGA4Events from './ga4.init-manual-events';

export const handleMockupsBannerClick = () => {
    q('a#mockups-banner')?.addEventListener('click', () =>
        triggerManualGA4Events({
            description: 'mockupsBannerClick',
            options: {
                location: 'landing_mockup_editor',
                action: 'mockup_editor',
                interaction_type: 'click',
                camp_name: '',
            },
        }),
    );
};
